import { type ElementType, forwardRef, type ReactNode } from 'react';

import { ribbonRecipe } from './Ribbon.css';
import { getClassNames } from '../../util/css';
import { RecipeVariants } from '../../vanilla-extract.css';

const sparkyClassName = 'sparky-ribbon';

type RibbonProps = RecipeVariants<typeof ribbonRecipe> & {
  as?: ElementType;
  children: ReactNode;
  className?: never;
  id?: string;
};

export const Ribbon = forwardRef<HTMLDivElement, RibbonProps>(
  ({ children, as: Tag = 'div', emphasis = 'high', size = 'small', className = '', id }, ref) => {
    const classNames = getClassNames(sparkyClassName, ribbonRecipe({ emphasis, size }), className);
    return (
      <Tag ref={ref} className={classNames} id={id}>
        {children}
      </Tag>
    );
  },
);

Ribbon.toString = () => `.${sparkyClassName}`;
Ribbon.displayName = 'Ribbon';

export default Ribbon;
